<script setup>
import { Button } from "@starline-security/component-library";
import { ref } from "vue";
const loading = ref(false);
</script>

<template>
  <div class="tw:p-4">
    <h1 class="tw:text-xl tw:mb-2 tw:underline">Buttons</h1>
    <p>Button XS</p>
    <div class="tw:mb-2 tw:flex tw:gap-2">
      <Button class="" variant="primary" size="xs">Primary xs</Button>
      <Button variant="secondary" size="xs" class="">Secondary xs</Button>
      <Button variant="secondary" size="xs" class="" :loading="true"
        >Secondary xs</Button
      >
      <Button
        variant="secondary"
        size="xs"
        class=""
        :loading="loading"
        @click="loading = !loading"
      >
        <svg-icon name="fa-check" /> <span>Click to show loading</span>
      </Button>
    </div>

    <p>Button XS Icon</p>
    <div class="tw:my-4 tw:flex tw:gap-2">
      <Button variant="primary" size="xs" class="" :icon-only="true">
        <svg-icon name="fa-check" />
      </Button>
      <Button variant="secondary" size="xs" class="" :icon-only="true">
        <svg-icon name="fa-check" />
      </Button>
      <Button variant="tertiary" size="xs" class="" :icon-only="true">
        <svg-icon name="fa-check" />
      </Button>
      <Button variant="link" size="xs" class="" :icon-only="true">
        <svg-icon name="fa-check" />
      </Button>
    </div>

    <p>Button SM</p>
    <div class="tw:mb-2 tw:flex tw:gap-2">
      <Button variant="primary" size="sm">Primary sm</Button>
      <Button variant="secondary" size="sm">Secondary sm</Button>
      <Button variant="secondary" size="sm" class="" :icon-only="true">
        <svg-icon name="fa-check" />
      </Button>
    </div>

    <p>Button MD</p>
    <div class="tw:mb-2 tw:flex tw:gap-2">
      <Button variant="primary" size="md">Primary md</Button>
      <Button variant="secondary" size="md">Secondary md</Button>
    </div>

    <p>Button LG</p>
    <div class="tw:mb-2 tw:flex tw:gap-2">
      <Button variant="primary" size="lg">Primary</Button>
      <Button variant="primary" size="lg" loading>Primary</Button>
      <Button variant="secondary" size="lg">Secondary</Button>
      <Button variant="tertiary" size="lg">Tertiary</Button>
      <Button variant="link" size="lg">Link</Button>
      <Button variant="tertiary" size="lg" disabled>Disabled Tertiary</Button>
      <Button variant="primary" size="lg" disabled>
        Primary Disabled Button</Button
      >
      <Button variant="secondary" size="lg" disabled>
        Secondary Disabled Button</Button
      >
    </div>
  </div>
</template>
